module.exports = __webpack_public_path__ + "img/banner-loja.006a42b9.jpeg";